function configureControls() {
    const { CKEDITOR } = window;

    // 2017-10-20 - removed change for 45202 because it causes several toolbar functions to stop working

    // case 45473 - use divs to avoid extraneous spacing after lines
    CKEDITOR.config.enterMode = CKEDITOR.ENTER_DIV;
    CKEDITOR.config.removePlugins = 'magicline';

    CKEDITOR.config.font_names =
        'Arial/Arial, Helvetica, sans-serif;Calibri/Calibri;Comic Sans MS/Comic Sans MS, cursive;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;Verdana/Verdana, Geneva, sans-serif';

    // disable tooltip
    CKEDITOR.config.title = false;

    // 53867 - Removing spell checker plugin and enabling native spell checker
    CKEDITOR.config.disableNativeSpellChecker = false;

    // patch for case 45487 - see that case for details
    var oldRanges = CKEDITOR.dom.selection.prototype.getRanges;

    var newCreateBookmarks2 = function (normalized) {
        return this.map(function (range) {
            try {
                return range.createBookmark2(normalized);
            } catch (e) {
                return null;
            }
        }).filter(function (b) {
            return b;
        });
    };

    CKEDITOR.dom.selection.prototype.getRanges = function () {
        var ranges = oldRanges.apply(this, arguments);

        ranges.createBookmarks2 = newCreateBookmarks2;

        return ranges;
    };
}

export default configureControls;
